module.exports = __webpack_public_path__ + "static/img/news_banner_01_zh.8505b86.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/news_banner_01_zh.png
// module id = lkK8
// module chunks = 34